export default "__VITE_ASSET__Cxg3CGbc__"